import * as Yup from "yup"

export const defaultSchema = (t: any) =>
  Yup.object().shape({
    regNumber: Yup.string()
      .min(6, t("global.regnr_must_be_6_characters", "Registration number must be 6 characters long"))
      .max(
        10,
        t("global.regnr_must_be_10_characters", "Registration number can be a maximum of 10 characters long.")
      ),
    internnumber: Yup.string().required(t("global.internnr_is_required", "Internal number is required")),
    companyId: Yup.number().nullable().required(t("global.company_is_required", "Company is required")),
    vehicleType: Yup.string().nullable(),
    basicFuelConsumptionKm: Yup.number(),
    averageSpeed: Yup.number(),
    mainPropellantId: Yup.number().nullable(),
    tachographIntegrationActive: Yup.bool(),
    archived: Yup.bool(),
    meterSetting: Yup.number().required(t("global.meter_setting_is_required", "Meter setting is required"))
  })
